import React from 'react'
import { Button, Grid, Stack, Typography } from '@mui/material'
import { useFieldArray } from 'react-hook-form'

import { TextFieldControl } from '../form'
import { Icon } from '../icon'

const MAX_EMAILS = 3
export const EmailFields = (): React.ReactElement => {
  const { fields, append, remove } = useFieldArray({
    name: 'emails',
  })

  const handleAddEmail = () => append({ value: '' })
  const handleRemoveEmail = (idx: number) => () => remove(idx)

  const canAddEmail = fields.length < MAX_EMAILS
  return (
    <Grid item>
      <Typography mb={2}>Укажите адреса, на которые отправить отчёт</Typography>
      <Stack direction="column" gap={2}>
        {fields.map((field, idx) => (
          <Stack direction="row" key={field.id} gap={2} alignItems="center">
            <TextFieldControl key={field.id} name={`emails.${idx}.value`} fullWidth label="Email" />
            {idx !== 0 && (
              <Button color="secondary" onClick={handleRemoveEmail(idx)}>
                Удалить
              </Button>
            )}
          </Stack>
        ))}
        {canAddEmail && (
          <Button onClick={handleAddEmail} sx={{ display: 'flex', alignItems: 'center' }}>
            <Icon name="Add" size="md" /> Добавить email
          </Button>
        )}
      </Stack>
    </Grid>
  )
}
